import { useMemo } from 'react';
import { ArrayParam, JsonParam, StringParam, withDefault } from 'use-query-params';
import { usePageParams } from '../../../../../hooks/usePageParams';
import { UniformityFilter } from '../../components/UniformityFilter/hooks/useUniformityFilter';

export type ClusterReportPageParams = {
  customerID: string; // Note: using customerID (not customerId) for consistency with context-aware navigation
  blocksSelected: (string | null)[] | undefined;
  variety: string;
  berriesPerCluster: string;
  uniformityFilter: UniformityFilter | undefined;
};

export function useClusterReportPageParams() {
  const config = useMemo(
    () => ({
      customerID: withDefault(StringParam, ''),
      blocksSelected: withDefault(ArrayParam, undefined),
      variety: withDefault(StringParam, ''),
      berriesPerCluster: withDefault(StringParam, 'all'),
      uniformityFilter: JsonParam,
    }),
    []
  );

  const result = usePageParams<ClusterReportPageParams>(config);

  return result;
}
